import React, {  useState } from 'react';
import { connect } from 'react-redux';
import { Row,
         Col,
         ListGroup,
         Form,
         Dropdown,
         ButtonGroup,
          } from 'react-bootstrap';
import Loader from './../../../../utilityComponents/Loader';
import Message from './../../../../utilityComponents/Message';
import { downloadXOSCFile,
         downloadGroundTruthFiles,
         downloadKPIFiles } from './../../../../actions/closeLoop/kpiDashboard/download/downloadReportsActions';
import KPIList from './../kpiList/kpiList';
import PropTypes from 'prop-types'


function ScenarioInfo(props) {
    const [ showToast, setShowToast ] = useState(false);

    const handleToast = () => { setShowToast(!showToast) }

    const xoscFileHandler = () => {
        if(props.scenarioUUID) {
            const payload = {
                scenario_uuid: props.scenarioUUID,
                bench_name: props.benchName,
                test_run_id: props.testRunId
            }
            props.downloadXOSC(payload);
        }
    }

    const groundTruthHandler = () => {
        if(props.benchName && props.testRunId && props.scenarioUUID) {
            const payload = {
                bench_name: props.benchName,
                test_run_id: props.testRunId,
                scenario_uuid: props.scenarioUUID
            }
            props.downloadGroundTruths(payload);
        }
    }

    const extractTimestamp = (testRunId) => {
        if(testRunId.toString().includes('-')) {
            const values = testRunId.toString().split('-');
            return Number(values[0]);
        }
        return Number(testRunId);
    }

    return (
        <>
            { (props.xoscFileLoading ||
                props.groundTruthFiles.loading ||
                props.kpiFiles.loading ) ? <Loader /> :
             (props.xoscFileError ||
                props.groundTruthFiles.error ||
                props.kpiFiles.error ) ? (
                <Message variant={'danger'}>
                    { props.xoscFileError || props.groundTruthFiles.error || props.kpiFiles.error }
                </Message>
             ) : (
                <>
                    <Row className="align-self-center">
                        <Col md={8} xl={8} className="align-self-center">
                            <h4>Scenario Info</h4>
                        </Col>
                        <Col md={4} xl={4} className="align-self-center">
                            { (props.testRunId && props.scenarioUUID) && (
                                <ButtonGroup>
                                    <Dropdown>
                                        <Dropdown.Toggle id="dropdown-basic">
                                            Download
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item
                                                onClick={() => { xoscFileHandler() }}
                                            >
                                                Xosc file
                                            </Dropdown.Item>
                                            <Dropdown.Divider />
                                            <Dropdown.Item
                                                onClick={() => { groundTruthHandler() }}
                                            >
                                                Ground Truth Files
                                            </Dropdown.Item>
                                            <Dropdown.Divider />
                                            <Dropdown.Item
                                                onClick={ () => { handleToast() } }
                                            >
                                                Show KPIs
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </ButtonGroup>
                            ) }
                        </Col>
                    </Row>
                    <ListGroup style={{ paddingTop: "1rem" }}>
                        { showToast && (
                            <ListGroup.Item>
                                <Row>
                                    <Col md={12} xl={12} className="text-center">
                                        <KPIList
                                            show={showToast}
                                            handleClose={handleToast}
                                        />
                                    </Col>
                                </Row>
                            </ListGroup.Item>
                        ) }
                        <ListGroup.Item>
                            <Row>
                                <Col md={6} xl={6}>
                                    Run ID :
                                </Col>
                                <Col md={6} xl={6}>
                                    {props.testRunId}
                                </Col>
                            </Row>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Row>
                                <Col md={6} xl={6}>
                                    Start time :
                                </Col>
                                <Col md={6} xl={6}>
                                    { props.testRunId ?
                                      new Date(extractTimestamp(props.testRunId)).toString()
                                      : undefined }
                                </Col>
                            </Row>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Row>
                                <Col md={6} xl={6}>
                                    Scenario ID :
                                </Col>
                                <Col md={6} xl={6}>
                                    {props.scenarioUUID}
                                </Col>
                            </Row>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Row>
                                <Col md={6} xl={6}>
                                    Scenario File Name :
                                </Col>
                                <Col md={6} xl={6}>
                                    {props.scenarioFileName}
                                </Col>
                            </Row>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Row>
                                <Col md={6} xl={6}>
                                    Scenario
                                    Description :
                                </Col>
                                <Col md={6} xl={6}>
                                    <Form.Control
                                        as='textarea'
                                        disabled={true}
                                        value={props.description}
                                    >
                                    </Form.Control>
                                </Col>
                            </Row>
                        </ListGroup.Item>
                    </ListGroup>
                </>
             )}
         </>
    )
}

ScenarioInfo.propTypes={
    scenarioUUID:PropTypes.string,
    downloadXOSC:PropTypes.func,
    benchName:PropTypes.string,
    testRunId:PropTypes.string,
    downloadGroundTruths:PropTypes.func,
    xoscFileLoading:PropTypes.bool,
    groundTruthFiles:PropTypes.object,
    kpiFiles:PropTypes.object,
    xoscFileError:PropTypes.string,
    scenarioFileName:PropTypes.string,
    description:PropTypes.string
}

const mapStateToProps = (state) => ({
    xoscFileLoading: state.individualDashboardReports.loading,
    xoscFileError: state.individualDashboardReports.error,
    testRunId: state.dashboardFilterData.info.selectData.runId,
    benchName: state.dashboardFilterData.info.selectData.benchName,
    scenarioUUID: state.dashboardFilterData.info.selectData.scenarioId,
    description: state.dashboardFilterData.info.selectData.description,
    scenarioFileName: state.dashboardFilterData.info.selectData.scenarioFileName,
    // KPI Ground Truth Files
    groundTruthFiles: {
        loading: state.individualGroundTruthReports.loading,
        error: state.individualGroundTruthReports.error
    },
    // Fetching Available KPI's
    kpiList: state.availableKPIList.kpiList,
    // KPI Files
    kpiFiles: {
        loading: state.downloadKPIFiles.loading,
        error: state.downloadKPIFiles.error
    }
})

const mapDispatchToProps = (dispatch) => ({
    downloadXOSC: (payload) => dispatch(downloadXOSCFile(payload)),
    downloadGroundTruths: (payload) => dispatch(downloadGroundTruthFiles(payload)),
    downloadKPIReports: (payload) => dispatch(downloadKPIFiles(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ScenarioInfo);